import { Button, Col, Form, Input, Row, Typography } from "antd";
import { ArrowRight } from "lucide-react";
import { normalizePhoneNumber } from "../signup.service";

const { Title, Paragraph } = Typography;

function Step1Identity({ onNext }) {
  return (
    <>
      <Title level={4} style={{ marginBottom: 4 }}>
        Your Identity
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 24 }}>
        Let&apos;s start with your basic details.
      </Paragraph>

      <Row gutter={[16, 0]}>
        <Col xs={24} md={12}>
          <Form.Item
            name="name"
            label="Full Name"
            rules={[
              {
                required: true,
                whitespace: true,
                message: "Full name is required.",
              },
            ]}
          >
            <Input placeholder="John Doe Studio" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="email"
            label="Work Email"
            rules={[
              {
                required: true,
                whitespace: true,
                message: "Email is required.",
              },
              { type: "email", message: "Enter a valid email address." },
            ]}
          >
            <Input type="email" placeholder="you@example.com" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="phone"
            label="Mobile Number"
            rules={[
              { required: true, whitespace: true, message: "" },
              {
                validator: (_, v) =>
                  normalizePhoneNumber(v || "").length === 10
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error("Enter a valid 10-digit number.")
                      ),
              },
            ]}
          >
            <Input type="tel" inputMode="numeric" placeholder="9876543210" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="gst_number"
            label="GST Number (Optional)"
            rules={[
              {
                pattern:
                  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                message: "Enter a valid GST number (e.g. 29ABCDE1234F1Z5).",
              },
            ]}
          >
            <Input
              placeholder="29ABCDE1234F1Z5"
              style={{ textTransform: "uppercase" }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row justify="end" style={{ marginTop: 8 }}>
        <Col>
          <Button
            type="primary"
            onClick={onNext}
            icon={<ArrowRight size={14} />}
            iconPosition="end"
          >
            Next: Community
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default Step1Identity;
